import pathOr from 'ramda/src/pathOr';

export function getLocale () {
    // get browser locale language property, else default to en-US
    let lang = navigator.language || navigator.browserLanguage || 'en-us';
    return lang.toLowerCase();
}

export function getSiteLocale () {
    return pathOr( 'en-us', ['conf', 'locale'], window.upi );
}

export function getSiteEnv () {
    return pathOr( 'local', ['conf', 'env'], window.upi );
}

export function getLanguageCode () {
    return getSiteLocale().split( '-' )[0];
}

export function getCountryCode () {
    return getSiteLocale().split( '-' )[1];
}

export function getFacebookLocale () {
    switch ( getLocale() ) {
        case 'zh-cn':
            return 'zh_CN';
        case 'de':
            return 'de_DE';
        case 'es':
            return 'es_ES';
        case 'es-la':
            return 'es_LA';
        case 'fr':
            return 'fr_FR';
        case 'it':
            return 'it_IT';
        case 'ja':
            return 'ja_JP';
        case 'pt-br':
            return 'pt_BR';
        case 'ru':
            return 'ru_RU';
        case 'tr':
            return 'tr_TR';
        case 'hr':
            return 'hr_HR';
        case 'in':
            return 'hi_IN';
        default:
            return 'en_US';
    }
}
